<template>
    <div class="my-2">
        <StatsBar
            :stats="{ pass: spec.compliant, fail: spec.nonCompliant }"
            :stats-before="statsBefore"
            :statistics="{
                totalEmailsReported: spec.compliant + spec.nonCompliant,
                dmarcCompliant: spec.compliant,
                dmarcNonCompliant: spec.nonCompliant,
                complianceRate: spec.complianceRate,
            }"
        />
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import StatsBar from "@/Pages/Reports/components/StatsBar.vue";
import type { AiStatsSpec } from "@/Pages/AiChat/markdown";

const props = defineProps<{
    spec: AiStatsSpec;
}>();

const statsBefore = computed(() =>
    props.spec.before
        ? {
              pass: props.spec.before.compliant,
              fail: props.spec.before.nonCompliant,
          }
        : null,
);
</script>
